import React, { useEffect, useState } from 'react';
import {
  ModalOverlay,
  ModalContainer,
  ModalTitle,
  ModalDescription,
  ModalContent,
  LeftSection,
  RightSection,
  SchoolTag,
  CustomPlanTitle,
  CustomPlanDescription,
  RequestQuoteButton,
  AllInclusiveBanner,
  FeaturesGrid,
  FeatureItem,
  CheckIcon,
  CloseButton
} from './style';
import darkCheckCircle from '../../../static/icons/dark-check-circle.svg';
import SchoolPlanEnquiry from '../SchoolPlanEnquiry';
import { track as trackProductEvent } from '../../../utils/productEvents';


// `feature` names what was locked (e.g. "Class Insights") so the sales email says what they reached for.
const SchoolPlanModal = ({ isOpen, onClose, feature = '' }) => {
  const [showEnquiry, setShowEnquiry] = useState(false);

  useEffect(() => {
    if (!isOpen) setShowEnquiry(false);
    if (isOpen) {
      trackProductEvent('paywall_shown', { trigger: 'locked_feature' });
    }
  }, [isOpen]);

  if (!isOpen) return null;

  const leftColumnFeatures = [
    "Full class access",
    "Unlimited drafts submissions", 
    "AI-assisted feedback",
    "Control student AI usage",
    "Curriculum-aligned rubrics",
    "Comment banks",
    "Teacher customisations",
    "Task creation"
  ];

  const rightColumnFeatures = [
    "Handwritten uploads",
    "Self-assessment",
    "Peer review", 
    "Exemplars",
    "Class insights",
    "LMS integrations",
    "Onboarding and training",
    "24/7 Support"
  ];

  // The enquiry form replaces this modal; it emails the sales inbox as it opens.
  if (showEnquiry) {
    return (
      <SchoolPlanEnquiry
        isOpen
        onClose={onClose}
        source="Locked feature"
        trigger={feature || 'This feature is only available in the school plan'}
      />
    );
  }

  return (
    <ModalOverlay onClick={onClose}>
      <ModalContainer onClick={(e) => e.stopPropagation()}>
        <CloseButton
          onClick={() => {
            trackProductEvent('paywall_clicked', { trigger: 'locked_feature', action: 'dismissed' });
            onClose?.();
          }}
        >
          ×
        </CloseButton>
        
        <ModalTitle>This feature is only available in the school plan</ModalTitle>
        <ModalDescription>
          The best way to learn and improve your skills. Get feedback on your work from JeddAI or go pro with your real-life experts.
        </ModalDescription>
        <AllInclusiveBanner>ALL INCLUSIVE</AllInclusiveBanner>
        <ModalContent>
          <LeftSection>
            <SchoolTag>SCHOOL</SchoolTag>
            <CustomPlanTitle>Custom plan</CustomPlanTitle>
            <CustomPlanDescription>Add your classes, give feedback effortlessly</CustomPlanDescription>
            <RequestQuoteButton
              onClick={() => {
                trackProductEvent('paywall_clicked', {
                  trigger: 'locked_feature',
                  action: 'school_plan',
                  plan_type: 'school',
                });
                setShowEnquiry(true);
              }}
            >
              Request a quote
            </RequestQuoteButton>
          </LeftSection>

          <RightSection>
          
            <FeaturesGrid>
              <div>
                {leftColumnFeatures.map((feature, index) => (
                  <FeatureItem key={index}>
                    <CheckIcon><img src={darkCheckCircle} /></CheckIcon>
                    <span>{feature}</span>
                  </FeatureItem>
                ))}
              </div>
              <div>
                {rightColumnFeatures.map((feature, index) => (
                  <FeatureItem key={index}>
                    <CheckIcon><img src={darkCheckCircle} /></CheckIcon>
                    <span>{feature}</span>
                  </FeatureItem>
                ))}
              </div>
            </FeaturesGrid>
          </RightSection>
        </ModalContent>
      </ModalContainer>
    </ModalOverlay>
  );
};

export default SchoolPlanModal;
